<template>
  <div class="store-detail">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.distributorInfo')">
      <!-- <div class="right-header">
        <img class="icon-img" src="@/assets/images/map_time.png" alt="" @click="toPage(`/shared/mappingActivity?customerId=${customerInfo.id}&pageType=salesDistribution`)">
      </div> -->
      <div class="right-header" v-if="paramsUrl.readOnly !== 'true'">
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          placement="left-start"
          get-container=".distributor-detail"
        >
          <template #reference>
            <van-icon name="ellipsis" />
          </template>
        </van-popover>
      </div>
    </NavHeaderBar>
    <div class="detail-main-content">
      <div class="mark-info">
        <span class="customer-name">{{ customerInfo.sdName }}</span>
      </div>
      <XuStoreInfo :customerInfo="customerInfo" :shelfList="shelfList" :retailList="retailList" :decisionContact="decisionContact" :pageType="pageType" @getCustomerInfo="getCustomerInfo" />
    </div>
    <div class="oper-bottom-btn" v-if="paramsUrl.readOnly !== 'true'">
      <van-button v-if="checkPer(['admin', 'app:sd:updateSd'])" class="left-btn"  @click="toPage(`/salesDistribution/sdMapping?customerId=${customerInfo.id}`)">{{ $t('shared.mapping') }}</van-button>
      <van-button v-if="checkPer(['admin', 'app:sdVisit:addOrUpdate'])" class="center-btn" @click="toPage(`/salesDistribution/sdVisit?customerId=${customerInfo.id}`, 'visit')">{{ $t('shared.visitSellIn') }}</van-button>
      <van-button v-if="checkPer(['admin', 'app:eventSd'])" class="right-btn" @click="toPage('/event?pageType=salesDistribution')">{{ $t('shared.event') }}</van-button>
    </div>
    <XuVisitDialog ref="xuVisitDialogRef" :currentVisitInfo="currentVisitInfo" :customerId="customerInfo.id" :pageType="pageType" />
  </div>
</template>

<script>
import { sdInfoApi, arsSdVisitLastApi } from '@/api/salesDistribution'
import { Toast } from 'vant'
import { mapState } from 'vuex'
export default {
  components: {
    XuStoreInfo: () => import('@/components/XuStoreInfo'),
    XuVisitDialog: () => import('@/components/XuVisitDialog')
  },
  data () {
    return {
      pageType: 'salesDistribution',
      paramsUrl: {},
      customerInfo: {},
      decisionContact: {},
      retailList: [],
      shelfList: [],
      currentVisitInfo: {},
      showPopover: false
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getCustomerInfo()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    actions () {
      const newArr = []
      newArr.push({ text: this.$t('shared.storeActivity'), icon: require('@/assets/images/map_time.png'), type: 'activity' })
      newArr.push({ text: this.$t('shared.relevantVisitPlans'), icon: require('@/assets/images/record.png'), type: 'plan' })
      return newArr
    }
  },
  methods: {
    onSelect (action, index) {
      if (action.type === 'activity') {
        this.$router.push(`/shared/mappingActivity?customerId=${this.customerInfo.id}&pageType=salesDistribution`)
      } else if (action.type === 'plan') {
        this.$router.push(`/visitPlan?targetId=${this.customerInfo.id}&targetType=1&pageType=salesDistribution`)
      }
    },
    getCustomerInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      sdInfoApi(this.paramsUrl.customerId).then(res => {
        Toast.clear()
        const { decisionContact, retailList, shelfProjectList } = res.data
        this.customerInfo = res.data
        this.decisionContact = decisionContact
        this.retailList = retailList
        this.shelfList = shelfProjectList
      })
    },
    toPage (url, type) {
      if (!url) {
        return
      }
      if (type === 'visit') {
        if (!this.customerInfo.id) {
          return
        }
        Toast.loading({
          message: this.$t('shared.loading'),
          forbidClick: true,
          duration: 0
        })
        arsSdVisitLastApi(this.customerInfo.id, '0').then(res => {
          Toast.clear()
          this.currentVisitInfo = res.data
          if (res.data.lastType === 0) {
            this.$router.push(url)
          } else {
            this.$refs.xuVisitDialogRef.dialogShow = true
          }
        })
        return
      }
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.store-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .detail-main-content {
    flex: 1;
    overflow-y: auto;
  }
  .right-header {
    display: flex;
    align-items: center;
    margin-left: 10px;
    .icon-img {
      width: 20px;
      height: 20px;
    }
  }
  .mark-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    font-weight: 700;
    color: #555;
    .customer-name {
      font-size: 14px;
      word-break: break-word;
      text-align: center;
    }
    .center-btn {
      padding: 2px 5px;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: 400;
      font-size: 1;
      border: 1px solid #307bff;
      color: #307bff;
      font-weight: 400;
      font-size: 12px;
      margin-right: 3px;
    }
    .incentive-label {
      background: rgba(238, 84, 27, 0.19);
      border: 1px solid #ee541b;
      color: #ee541b;
    }
  }
  .detail-btn {
    display: flex;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
    .current-btn,
    .more-btn {
      flex: 1;
      border: none;
      font-weight: bold;
    }
    .current-btn {
      background-color: #307bff;
      color: #fff;
    }
    .more-btn {
      color: #555;
    }
  }
}
.oper-bottom-btn {
  .left-btn {
    background-color: #307bff;
    color: #fff;
  }
  .center-btn {
    color: #fff;
    margin: 0 1px;
    background-color: #0db00b;
  }
  .right-btn {
    background-color: #ee541b;
  }
}
/deep/.van-popover__action {
  width: 200px;
}
/deep/.van-popover__action-text {
  text-align: left;
}
</style>
